
const region = "ap-south-1";
const bucket = "coobo";

module.exports = "https://coobo-prod.azureedge.net/assets";


//////////////////
// WEBPACK FOOTER
// ../configs/s3url.js
// module id = keRX
// module chunks = 1